import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import CampaignUpdate from "components/CampaignUpdate/CampaignUpdate";
import useGetCampaignUpdate from "pages/campaign/hooks/useGetCampaignUpdate";
import "./_style.scss";
const urlHasShareSuffix = () => /\/share\/?$/.test(window.location.pathname);
function CampaignUpdateModal({ update: initialUpdate, campaign, onClose, onReactionsChange, onCommentAdded, isCommentsEnabled = true, showShareOnOpen, }) {
    const { update: fetchedUpdate, refetch } = useGetCampaignUpdate({ id: initialUpdate.id });
    const update = fetchedUpdate !== null && fetchedUpdate !== void 0 ? fetchedUpdate : initialUpdate;
    // Re-checked against the URL (rather than trusting the prop forever) so that once the
    // share modal has been dismissed, remounting this modal (e.g. by switching tabs away and
    // back) doesn't auto-open it again.
    const [shouldOpenShare, setShouldOpenShare] = useState(() => !!showShareOnOpen && urlHasShareSuffix());
    const handleCommentAdded = () => {
        refetch();
        onCommentAdded === null || onCommentAdded === void 0 ? void 0 : onCommentAdded();
    };
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                onClose();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [onClose]);
    useEffect(() => {
        const previous = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = previous;
        };
    }, []);
    return (_jsx("div", { className: "campaign-update-modal__overlay", role: "dialog", "aria-modal": "true", "aria-label": update.title, children: _jsx("div", { className: "campaign-update-modal__container", children: _jsx(CampaignUpdate, { update: update, campaign: campaign, onClose: onClose, onReactionsChange: onReactionsChange, onCommentAdded: handleCommentAdded, isCommentsEnabled: isCommentsEnabled, showShareOnOpen: shouldOpenShare, onShareModalClose: () => setShouldOpenShare(false) }) }) }));
}
export default CampaignUpdateModal;
